import { createSlice, PayloadAction } from '@reduxjs/toolkit';
// import { encryptData, decryptData } from '@/lib/encryption';

interface AuthState {
  user: {
    name: string | null;
    email: string;
    phone: string | null;
    address: string | null;
  } | null;
  accessToken: string | null;
  loginType: 'regular' | 'token' | null;
  lastActivity: number;
}

const initialState: AuthState = {
  user: null,
  accessToken: null,
  loginType: null,
  lastActivity: Date.now()
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<AuthState['user']>) => {
      state.user = action.payload;
      state.lastActivity = Date.now();
    },
    setAccessToken: (state, action: PayloadAction<string>) => {
      state.accessToken = action.payload;
      state.lastActivity = Date.now();
    },
    setLoginType: (state, action: PayloadAction<AuthState['loginType']>) => {
      state.loginType = action.payload;
    },
    updateLastActivity: (state) => {
      state.lastActivity = Date.now();
    },
    logout: (state) => {
      state.user = null;
      state.accessToken = null;
      state.loginType = null;
      state.lastActivity = 0;
    },
    loginSuccess: (state, action: PayloadAction<{ user: AuthState['user']; accessToken: string; loginType: AuthState['loginType'] }>) => {
      state.user = action.payload.user;
      state.accessToken = action.payload.accessToken;
      state.loginType = action.payload.loginType;
      state.lastActivity = Date.now();
    }
  }
});

export const { setUser, setAccessToken, setLoginType, updateLastActivity, logout, loginSuccess } = authSlice.actions;
export default authSlice.reducer;